import React from 'react';
import {
  DialogModal,
  DialogModalProps,
} from '../../../../../../theme/components';
import { useFormik } from 'formik';
import { SettingsAPI } from '../../../../../../redux/settings/api/SettingsAPI';
import {
  FormControl,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { getPolyglot } from '../../../../../../i18n';
import HelperText from '../../../../../../theme/components/Forms/HelperText';
import useLabFilters from './useLabFilters';

function LabFiltersModal(props: DialogModalProps) {
  const [saveSettings, { isLoading }] =
    SettingsAPI.useSetManySettingsMutation();
  const polyglot = getPolyglot();
  const { data: initialValues } = useLabFilters();
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const settings = {
        labConnectionFeature: values.labConnectionFeature.toString(),
        labBandwidthFeature: values.labBandwidthFeature.toString(),
        labTableFeature: values.labTableFeature.toString(),
      };
      await saveSettings({ settings });
      props.onClose?.();
    },
  });
  return (
    <DialogModal
      loading={isLoading}
      {...props}
      onConfirm={() => formik.handleSubmit()}
    >
      <Stack spacing={2}>
        <Typography>{polyglot.t('lab.info')}</Typography>
        <FormControl fullWidth>
          <FormControlLabel
            control={
              <Switch
                defaultChecked={formik.values.labConnectionFeature}
                onChange={formik.handleChange}
                name="labConnectionFeature"
              />
            }
            label={polyglot.t('lab.connection_feature')}
          />
          <HelperText>
            {polyglot.t('lab.connection_feature_description')}
          </HelperText>
        </FormControl>

        <FormControl fullWidth>
          <FormControlLabel
            control={
              <Switch
                defaultChecked={formik.values.labBandwidthFeature}
                onChange={formik.handleChange}
                name="labBandwidthFeature"
              />
            }
            label={polyglot.t('lab.bandwidth_feature')}
          />
          <HelperText>
            {polyglot.t('lab.bandwidth_feature_description')}
          </HelperText>
        </FormControl>

        <FormControl fullWidth>
          <FormControlLabel
            control={
              <Switch
                defaultChecked={formik.values.labTableFeature}
                onChange={formik.handleChange}
                name="labTableFeature"
              />
            }
            label={polyglot.t('lab.show_table_feature')}
          />
          <HelperText>
            {polyglot.t('lab.show_table_feature_description')}
          </HelperText>
        </FormControl>
      </Stack>
    </DialogModal>
  );
}

export default LabFiltersModal;
